import gql from 'graphql-tag';

export default gql`
    query GetLoadIdAndSandPo($input: GetLoadIdAndSandPoInput) {
        getLoadIdAndSandPo(input: $input) {
            loadId
            sandPO
        }
    }
`;
